export default __webpack_public_path__ + "static/media/send.b3404d4a.svg";